export default __webpack_public_path__ + "static/media/NanumSquareR.94ee92ff.woff";